
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/women/[...slug]",
      function () {
        return require("private-next-pages/women/[...slug].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/women/[...slug]"])
      });
    }
  